import { Box, Typography } from "@mui/material";

export const NotFound = () => {
  return (
    <Box
      height="50vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="h5">404 | Page Not Found</Typography>
    </Box>
  );
};
